var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.details,"footer-props":{
    'items-per-page-options': _vm.data.itemsPerPageOptions,
    'show-current-page': true,
    'show-first-last-page': true,
  },"options":_vm.options,"server-items-length":_vm.data.totalItems,"fixed-header":"","dense":"","hide-default-footer":_vm.data.loading,"loading":_vm.data.changingPage},on:{"update:options":[function($event){_vm.options=$event},function($event){return _vm.updateOptions()}]},scopedSlots:_vm._u([{key:"item.fromImportance",fn:function(ref){
  var item = ref.item;
return [(item.fromImportance || item.fromImportance === 0)?_c('span',[_vm._v(" "+_vm._s(item.fromImportance)+" ")]):_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
  var on = ref.on;
  var attr = ref.attr;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"small":""}},'v-icon',attr,false),on),[_vm._v(" mdi-border-none-variant ")])]}}],null,true)},[_c('span',{attrs:{"small":""}},[_vm._v("Not processed")])])]}},{key:"item.fromPage",fn:function(ref){
  var item = ref.item;
return [_c('UrlLink',{attrs:{"to":{
        name: 'checkList-page-keywords',
        params: {
          domain: _vm.domain,
          propertyId: _vm.propertyId,
          pageId: item.fromPageId,
          pageUrl: _vm.toHex(item.fromUrl),
        },
      },"url":decodeURI(item.fromUrl)}})]}},{key:"item.toPage",fn:function(ref){
      var item = ref.item;
return [(item.isStrongMatch === false)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
      var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"pr-1",attrs:{"small":"","color":"orange darken-2"}},'v-icon',attrs,false),on),[_vm._v(" mdi-alert-outline ")])]}}],null,true)},[_c('span',[_vm._v("Href was only loosely matched with the linked page and/or there were variations in the link text")])]):_vm._e(),(item.toPageId)?_c('UrlLink',{attrs:{"to":{
        name: 'checkList-page-keywords',
        params: {
          domain: _vm.domain,
          propertyId: _vm.propertyId,
          pageId: item.toPageId,
          pageUrl: _vm.toHex(item.matchedToUrl),
        },
      },"url":decodeURI(item.toUrl),"hoverUrl":item.matchedToUrl,"maxLength":200}}):_c('span',[_vm._v(" "+_vm._s(item.toUrl)+" ")])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }